module.exports = __webpack_public_path__ + "img/facebook.6e5ecaaa.png";